<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">

      <el-form-item class="full" label="处置资产:">
        <div class="material-table">
          <el-table :data="form.assets" border>
            <el-table-column prop="number" label="资产编号" width="110px">
            </el-table-column>
            <el-table-column prop="name" label="资产名称">
            </el-table-column>
            <el-table-column prop="attribute.name" label="资产属性" width="90px">
            </el-table-column>
            <el-table-column prop="spec" label="规格型号" width="140px">
            </el-table-column>
            <el-table-column prop="price" label="购置金额" width="75px">
            </el-table-column>
            <el-table-column prop="purchaseTime" label="购置时间" width="110px">
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
      <el-form-item label="处置申请时间:">
        {{getTime(form.flow.createTime)}}
      </el-form-item>
      <el-form-item label="处置申请人:">
        <user-info :userData='form.flow.creator'></user-info>
      </el-form-item>

      <el-form-item label="处置形式:">
        {{form.type}}
      </el-form-item>
      <el-form-item label="是否三重一大:">
        {{form.szyd=='0'?'否':'是'}}
      </el-form-item>
      <el-form-item label="处置原因:" class="full">
        {{form.reason}}
      </el-form-item>
      <el-form-item label="清理相关:" class="full">
        {{form.qlfy}}
      </el-form-item>

      <el-form-item label="买方单位:">
        {{form.mfdw}}
      </el-form-item>
      <el-form-item label="发票号:">
        {{form.invoice}}
      </el-form-item>
      <el-form-item label="金额:">
        {{form.price}}
      </el-form-item>

    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {},
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(time) {
        return util.getFormatDate(time, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/components/handle.vue